import { Component, Input } from '@angular/core';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { Produto } from 'src/app/core/models/produto.model';
import { WeblabService } from 'src/app/core/services/weblab.service';

@Component({
  selector: 'app-novo-pedido-outros-servicos',
  templateUrl: './novo-pedido-outros-servicos.component.html',
  styleUrls: ['./novo-pedido-outros-servicos.component.scss']
})
export class NovoPedidoOutrosServicosComponent {
  @Input() servicosAdicionados: Produto[] = [];
  @Input() legend: string;
  @Input() codLoja: number | undefined;
  @Input() codCliente: number | undefined;
  @Input() filtrarSomenteNaoLentes: boolean = true;

  servicoSelecionado: any;
  quantidadeAddStr: string = '1';
  comboOutrosServicosFiltrado: Produto[] = [];

  constructor(private service: WeblabService) {}

  async filterAutoComplete(event: AutoCompleteCompleteEvent) {
    if (!this.codLoja || !this.codCliente || event.query.length < 2) {
      this.comboOutrosServicosFiltrado = [];
      return;
    }

    try {
      const resp: any = await new Promise((resolve, reject) =>
        this.service.produtosBusca(this.codLoja!, this.codCliente!, event.query).subscribe({ next: resolve, error: reject })
      );

      let produtos = (resp?.Produtos || []).map((p: Produto) => {
        const vlr_venda_tratado = p.vlr_fab > 0 ? p.vlr_fab : p.vlr_venda;
        const perc_desconto = p.desc_acresc_porcentagem === null ? 0 : p.desc_acresc_porcentagem;
        return {
          ...p,
          desc_acresc_porcentagem: perc_desconto,
          vlr_venda_tratado,
          vlr_liquido_produto: vlr_venda_tratado > 0 && perc_desconto > 0
            ? vlr_venda_tratado - (vlr_venda_tratado * perc_desconto / 100)
            : vlr_venda_tratado
        };
      });

      if (this.filtrarSomenteNaoLentes) {
        produtos = produtos.filter((p: Produto) => p.especie?.toLowerCase() !== 'lente');
      }

      this.comboOutrosServicosFiltrado = produtos;
    } catch {
      this.comboOutrosServicosFiltrado = [];
    }
  }

  onQuantidadeBlur(): void {
    const parsed = parseFloat((this.quantidadeAddStr || '1').replace(',', '.'));
    const snapped = Math.round((isNaN(parsed) || parsed < 0.5 ? 1 : parsed) * 2) / 2;
    const isHalf = snapped % 1 !== 0;
    this.quantidadeAddStr = snapped.toLocaleString('pt-BR', {
      minimumFractionDigits: isHalf ? 1 : 0,
      maximumFractionDigits: 1
    });
  }

  adicionarServico() {
    if (this.servicoSelecionado) {
      const qty = parseFloat((this.quantidadeAddStr || '1').replace(',', '.'));
      this.servicoSelecionado.quantidadeAdd = isNaN(qty) || qty <= 0 ? 1 : qty;
      this.servicosAdicionados.push(this.servicoSelecionado);
    }

    this.servicoSelecionado = null;
    this.quantidadeAddStr = '1';
  }

  deletarServico(_servico: any, index: any) {
    this.servicosAdicionados.splice(index, 1);
  }
}
